import produce from "immer";
import { constants } from "./actions";
import { commonConstants } from "../common/actions";
import moment from "moment";
import { callReportsUtils } from "./utils";

const { REQUEST, SUCCESS, FAILURE } = commonConstants;
const {
  FETCH_LIST,
  UPDATE_DATE_FILTER,
  DELETE_CALL_REPORT,
  UPDATE_CALL_REPORTS_FILTERS,
  RESET_CALL_REPORTS_FILTERS,
} = constants;
const { sanitizeDateRange } = callReportsUtils;

export const initState = {
  list: [],
  unfilteredList: [],
  callTakers: [],
  toDateFilter: moment().utc(),
  fromDateFilter: moment().utc().subtract("3", "month"),
  // async
  loading: {},
  error: {},
  success: {},
  tableState: {
    filtered: [],
    sorted: [{ id: "callStart", desc: true }],
    page: 0,
    pageSize: 100,
  },
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case UPDATE_DATE_FILTER:
      return produce(state, (draft) => {
        const { fromDate, toDate } = action.payload;
        const { sanitizedFromDate, sanitizedToDate, message } = sanitizeDateRange(
          fromDate,
          toDate,
        );
        draft.fromDateFilter = sanitizedFromDate;
        draft.toDateFilter = sanitizedToDate;
        if (message) {
          draft.error = {
            source: UPDATE_DATE_FILTER,
            message,
          };
        }
      });
    case UPDATE_CALL_REPORTS_FILTERS:
      return produce(state, (draft) => {
        draft.tableState[action.field] = action.value;
      });
    case RESET_CALL_REPORTS_FILTERS:
      return produce(state, (draft) => {
        draft.tableState = initState.tableState;
      });
    case FETCH_LIST + REQUEST:
      return produce(state, (draft) => {
        draft.success = {};
        draft.loading = { source: FETCH_LIST };
        draft.error = {};
      });
    case DELETE_CALL_REPORT + REQUEST:
      return produce(state, (draft) => {
        draft.success = {};
        draft.loading = { source: DELETE_CALL_REPORT };
        draft.error = {};
      });
    case FETCH_LIST + SUCCESS:
      const callTakers = action.payload.callTakers;
      return produce(state, (draft) => {
        draft.success = {
          source: action.payload.source,
          message: action.payload.message,
        };
        draft.loading = {};
        draft.list = action.payload.list
          .map((i) => {
            const callTaker = callTakers.find((ct) => ct.id === i.callTakerId);
            return {
              ...i,
              listenerName: callTaker
                ? `${callTaker.firstName} ${callTaker.lastName}`
                : "",
              listenerEmail: callTaker ? callTaker.email : "",
            };
          });
        draft.unfilteredList = action.payload.list;
        draft.callTakers = action.payload.callTakers;
        draft.toDateFilter = state.toDateFilter;
        draft.fromDateFilter = state.fromDateFilter;
      });
    case DELETE_CALL_REPORT + SUCCESS:
      return produce(state, (draft) => {
        draft.list = action.payload.list;
        draft.unfilteredList = action.payload.list;
        draft.success = {
          source: action.payload.source,
          message: action.payload.message,
        };
      });
    case FETCH_LIST + FAILURE:
    case DELETE_CALL_REPORT + FAILURE:
      return produce(state, (draft) => {
        draft.success = {};
        draft.error = {
          source: action.payload.source,
          message: action.payload.message,
        };
        draft.loading = {};
      });
    default:
      return produce(state, (draft) => {
        draft.list = state.list;
        draft.unfilteredList = state.unfilteredList;
        draft.callTakers = state.callTakers;
        draft.toDateFilter = state.toDateFilter;
        draft.fromDateFilter = state.fromDateFilter;
        draft.loading = state.loading;
        draft.success = state.success;
        draft.error = state.error;
      });
  }
}
